const configKeys = ['descriptions', 'fields', 'labels'];
const requiredFieldProperties = ['type', 'default_value'];
export const validTypes = ['boolean', 'number', 'string', 'text', 'image', 'background', 'color', 'select', 'select_field'];
export const accountLanguages = ['en-ca', 'en-gb', 'en-us', 'es-es', 'fr-ca', 'fr-ch', 'fr-fr', 'it-it', 'de-ch', 'de-de', 'nl-nl'];

export const defaultConfig = {
    fields: {},
    labels: {
        default: {}
    },
    descriptions: {}
};

//@Todo Remove if refacto format 'config_form_fields' permanent array
export function convertFieldsArrayToObject(fields) {
    if (fields && Array.isArray(fields)) {
        return fields.reduce((acc, field) => {
            const _field = { ...field };
            const key = _field.name;
            delete _field.name;
            acc[key] = _field;
            return acc;
        }, {});
    }

    return fields;
}

//@Todo Remove if refacto format 'config_form_fields' permanent array
function convertFieldsObjectToArray(fields) {
    if (fields && typeof fields === 'object' && !Array.isArray(fields)) {
        return Object.entries(fields).reduce((acc, [key, value]) => {
            acc.push({ ...value, name: key });
            return acc;
        }, []);
    }

    return fields;
}

export function mergeConfig(template = {}) {
    const configObject = {};
    if (!template) return configObject;
    configKeys.forEach(key => {
        if (Object.keys(template).includes(`config_form_${key}`)) {
            if (key === 'labels' || key === 'descriptions') {
                configObject[key] = { default: template[`config_form_${key}`], ...template['translations'][`config_form_${key}`] };
            }

            //@Todo Remove if refacto format 'config_form_fields' permanent array
            if (key === 'fields') {
                configObject['fields'] = convertFieldsArrayToObject(template['config_form_fields']);
            }
        }
    });

    return configObject;
}

export function splitConfig(config = {}) {
    const splittedTemplate = {
        config_form_fields: config.fields,
        config_form_labels: config.labels?.default,
        config_form_descriptions: config.descriptions?.default
    };

    //@Todo Remove if refacto format 'config_form_fields' permanent array
    splittedTemplate.config_form_fields = convertFieldsObjectToArray(splittedTemplate.config_form_fields);

    const labelsWithoutDefault = config?.labels && Object.keys(config.labels) && Object.entries(config.labels)?.filter(([lang, fields]) => lang !== 'default');
    const labelsTranslations = labelsWithoutDefault ? Object.fromEntries(labelsWithoutDefault) : {};

    const descriptionsWithoutDefault =
        config?.descriptions && Object.keys(config.descriptions) && Object.entries(config.descriptions)?.filter(([lang, fields]) => lang !== 'default');
    const descriptionsTranslations = descriptionsWithoutDefault ? Object.fromEntries(descriptionsWithoutDefault) : {};

    splittedTemplate['translations'] = { config_form_labels: labelsTranslations, config_form_descriptions: descriptionsTranslations };
    return splittedTemplate;
}

function validateBasicStructure(config, t, errors) {
    //check if all required keys are present
    configKeys.forEach(requiredKey => {
        if (!Object.keys(config).includes(requiredKey))
            errors.push({
                path: [requiredKey],
                message: t('ticket.ticket_design.create_template.options.warnings.missing_key', { key: requiredKey })
            });
    });

    //we check that the regex doesn't detect any non lowercase character in fields keys
    const regexLowerCaps = /[^a-z_]+/gm;
    const path = ['fields'];
    if (Object.keys(config).includes('fields'))
        Object.keys(config.fields).forEach(key => {
            const newPath = path.concat([key]);
            const matches = key.match(regexLowerCaps);
            if (matches?.length)
                errors.push({
                    path: newPath,
                    message: t('ticket.ticket_design.create_template.options.warnings.lower_key', {
                        invalid: matches.map(m => `"${m}"`).join(', '),
                        path: newPath.join('.'),
                        count: Math.max(matches.length, Math.max(matches.map(m => m.length)))
                    })
                });
        });

    //check the types of attributes
    Object.entries(config)?.forEach(([key, values]) => {
        if (typeof values !== 'object') {
            errors.push({
                path: [key],
                message: t('ticket.ticket_design.create_template.options.warnings.expected_type', { type: 'object', path: key })
            });
        } else {
            Object.entries(config[key])?.forEach(([value, fields]) => {
                if (typeof fields !== 'object' || Array.isArray(fields)) {
                    errors.push({
                        path: [key, value],
                        message: t('ticket.ticket_design.create_template.options.warnings.expected_type', { type: 'object', path: [key, value].join('.') })
                    });
                } else {
                    Object.entries(config[key][value])?.forEach(([field, properties]) => {
                        const fieldOptions = field.split('_');
                        const isArrayOptions =
                            Array.isArray(fieldOptions) &&
                            fieldOptions.length > 1 &&
                            fieldOptions[fieldOptions.length - 1] === 'options' &&
                            Object.keys(fields)?.includes(field.replace('_options', ''));
                        // type must be array for 'options' 'fields' properties and 'labels'
                        if (
                            !Array.isArray(properties) &&
                            ((key === 'fields' && field === 'options' && ['select', 'select_field'].includes(config[key][value]['type'])) || (key === 'labels' && isArrayOptions))
                        ) {
                            errors.push({
                                path: [key, value, field],
                                message: t('ticket.ticket_design.create_template.options.warnings.expected_type', { type: 'array', path: [key, value, field].join('.') })
                            });
                        }
                        // Validation options for select and select_field
                        if (((key === 'fields' && field === 'options') || (key === 'labels' && isArrayOptions)) && Array.isArray(properties))
                            properties.forEach(property => {
                                // 'options' array values must be validTypes for 'select_field's options
                                if (config[key][value]['type'] === 'select_field' && key === 'fields' && !validTypes.includes(property)) {
                                    const index = properties.indexOf(property);
                                    errors.push({
                                        path: [key, value, field, index],
                                        message: t('ticket.ticket_design.create_template.options.warnings.invalid_type', {
                                            type: property,
                                            valid: validTypes.join(', ')
                                        })
                                    });
                                } else {
                                    //Allow type of options for 'select' and allow only string for option'labels translations
                                    if (
                                        (!['string', 'boolean', 'number'].includes(typeof property) && key === 'fields') ||
                                        (!['string'].includes(typeof property) && key === 'labels')
                                    ) {
                                        const index = properties.indexOf(property);
                                        errors.push({
                                            path: [key, value, field, index],
                                            message: t('ticket.ticket_design.create_template.options.warnings.expected_type', {
                                                type: key === 'fields' ? 'string, boolean, number' : 'string',
                                                path: [key, value, field, index].join('.')
                                            })
                                        });
                                    }
                                }
                            });
                    });
                }
            });
        }
    });
    return errors;
}

function validateFields(config, t, errors) {
    const fields = config['fields'] || {};

    Object.entries(fields)?.forEach(([field, properties]) =>
        requiredFieldProperties.forEach(property => {
            //check if all fields have required properties
            if (!Object.keys(properties).includes(property)) {
                errors.push({
                    path: ['fields', field],
                    message: t('ticket.ticket_design.create_template.options.warnings.missing_fields_property', { property })
                });
            } else if (property === 'type' && !validTypes.includes(properties['type'])) {
                //check if type is valid
                errors.push({
                    path: ['fields', field, 'type'],
                    message: t('ticket.ticket_design.create_template.options.warnings.invalid_type', { type: properties['type'], valid: validTypes.join(', ') })
                });
            }
        })
    );

    return errors;
}

function validateTranslations(config, t, errors) {
    const fields = config['fields'] || {};

    ['descriptions', 'labels'].forEach(key => {
        const values = config[key] || {};

        //check if default language in labels
        if (Object.keys(fields)?.length > 0 && (Object.keys(values).length > 0 || key === 'labels') && !Object.keys(values)?.includes('default'))
            errors.push({
                path: [key],
                message: t('ticket.ticket_design.create_template.options.warnings.default', { key: key })
            });
        Object.entries(values)?.forEach(([language, properties]) => {
            //check if no invalid language
            if (language !== 'default' && !accountLanguages.includes(language)) {
                errors.push({
                    path: [key, language],
                    message: t('ticket.ticket_design.create_template.options.warnings.invalid_language', { language, valid: accountLanguages.join(', ') })
                });
            } else {
                //check if default have all fields in labels
                if (language === 'default' && key === 'labels') {
                    Object.keys(fields)?.forEach(field => {
                        if (!Object.keys(properties)?.includes(field))
                            errors.push({
                                path: [key, language],
                                message: t('ticket.ticket_design.create_template.options.warnings.missing_field', { field })
                            });
                        if (Object.keys(fields[field]).includes('options') && !Object.keys(properties)?.includes(`${field}_options`))
                            errors.push({
                                path: [key, language],
                                message: t('ticket.ticket_design.create_template.options.warnings.missing_field', { field: `${field}_options` })
                            });
                    });
                }
                //check if no undefined field
                Object.keys(properties).forEach(field => {
                    const fieldOptions = field.split('_');
                    const isArrayOptions =
                        Array.isArray(fieldOptions) &&
                        fieldOptions.length > 1 &&
                        fieldOptions[fieldOptions.length - 1] === 'options' &&
                        Object.keys(fields)?.includes(field.replace('_options', ''));
                    if (!Object.keys(fields)?.includes(field) && !isArrayOptions)
                        errors.push({
                            path: [key, language, field],
                            message: t('ticket.ticket_design.create_template.options.warnings.unknown', { field })
                        });
                });
            }
        });
    });

    return errors;
}

export function onValidateConfig(config = {}, t) {
    const errors = [];
    errors.concat(validateBasicStructure(config, t, errors));
    errors.concat(validateFields(config, t, errors));
    errors.concat(validateTranslations(config, t, errors));
    return errors;
}
